module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.iniFrame) ? _c('div', {
    attrs: {
      "id": "logo"
    }
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("../assets/logo.png")
    }
  })]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7539a629"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Logo.vue
// module id = 444
// module chunks = 1